import { useCached } from '../lib/cache'
import { useNav } from '../lib/nav'
import { Page, TopBar } from '../components/Shell'
import { useStore } from '../state/store'
import { Skeleton, Empty } from '../components/Skeleton'
import { I } from '../components/Icons'
import { loadPendingIntakes } from '../lib/api'
import { fmtC, LABEL, type PendingIntake } from '../lib/types'

/** Pieces that came in on a trade and are waiting to be finished as intakes (priced, sized, authenticated, listed, card printed). */
export function IntakePending() {
  const nav = useNav()
  const { setDraft, resetDraft } = useStore()
  const P = useCached<PendingIntake[]>('pending', loadPendingIntakes, { staleMs: 0 })   // D1: shown at once, re-read behind it
  const rows = P.data ?? null
  const err = rows ? '' : P.error
  const start = (p: PendingIntake) => {
    resetDraft()
    setDraft({
      type: 'bought', pendingId: p.id, tradeNo: p.trade_no, from: p.counterparty_name || 'Trade customer', cost: String(Math.round((p.credit_cents ?? p.cost_cents) / 100)),
      whose: (p.whose_piece === 'consignor' ? 'shane' : p.whose_piece), brand: p.brand, item: p.item, size: p.size ?? '', cond: p.condition, note: p.deal_note || `Trade-in credited against trade #${p.trade_no ?? ''}`,
    })
    nav('/intake')
  }
  const days = (d: string) => Math.floor((Date.now() - new Date(d).getTime()) / 86400000)
  return (
    <Page bar={<TopBar back="Intake" backTo="/intake" title="Pending from trades" caption={rows?.length ? `${rows.length} waiting` : ''} />}>
      {err && <div className="banner" style={{ background: '#d70015' }}>{err}</div>}
      <div className="hint">Each piece here came in on a trade with its credit as its cost. Tap one to finish the intake: size, measurements, authentication, then Shane prices it when he lists it. The intake card prints when it's recorded.</div>
      <div className="card">
        {rows === null && !err && <Skeleton rows={3} h={64} card={false} />}
        {(rows ?? []).map((p) => (
          <button key={p.id} type="button" className="person" onClick={() => start(p)}>
            <span className="person__initial" style={{ borderRadius: 10 }}>#{p.trade_no ?? '?'}</span>
            <span style={{ flexGrow: 1, minWidth: 0, textAlign: 'left' }}><span className="person__name">{p.brand} {p.item}{p.size ? ' Sz ' + p.size : ''}</span><span className="person__sub">{LABEL.cond[p.condition]} · {LABEL.whose[p.whose_piece]}'s piece · from {p.counterparty_name || 'trade customer'} · {days(p.created_at) === 0 ? 'today' : `${days(p.created_at)} day${days(p.created_at) === 1 ? '' : 's'} ago`}</span></span>
            <span style={{ fontWeight: 700 }}>{fmtC(p.credit_cents ?? p.cost_cents)}</span>
          </button>
        ))}
        {rows && rows.length === 0 && <Empty icon={I.trade(24)} line="Nothing waiting. Pieces land here when a trade is paid." />}
      </div>
    </Page>
  )
}
